import { render } from "./MinimizedTableCell.vue?vue&type=template&id=05711ee0&scoped=true"
import script from "./MinimizedTableCell.vue?vue&type=script&lang=js"
export * from "./MinimizedTableCell.vue?vue&type=script&lang=js"

import "./MinimizedTableCell.vue?vue&type=style&index=0&id=05711ee0&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05711ee0"]])

export default __exports__